import React, { useContext } from 'react'
import { ShopContext } from '../Context/ShopContext'
import drop_down from '../Components/Assets/dropdown_icon.png'
import Item from '../Components/Items/Item'
import '../Pages/CSS/ShopCategory.css'

const ShopCategory = (props) => {
  const { All_product } = useContext(ShopContext);
  return (
    <div className='shop-category'>
      <img src={props.banner} alt="" className='shop-category-banner' />
      <div className="shop-category-indexsort">
        <p>
          <span>Showing 1-12</span> out of 36 products
        </p>
        <div className="shop-category-sort">
          Sort by <img src={drop_down} alt="" />
        </div>
      </div>
      <div className="shop-category-products">
        {All_product.map((item, i) => {
          if (props.category === item.category) {
            return <Item key={i} id={item.id} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
          } else {
            return null;
          }
        })}
      </div>
      <div className="shop-category-loadmore">
        Explore More
      </div>
    </div>
  )
}

export default ShopCategory
